<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
      <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
          <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">Unsubscribe Successfully</h1>
          <vs-button size="large" to="/">Back to Home</vs-button>
      </div>
    </div>
</template>


<script>
import { unsubscribe } from '@/api/campaign'

export default {
  data: () => ({}),
  created(){
    this.unsubscribe();
  },
  methods: {
    unsubscribe() {
      try{
        console.log(this.$route.query.token)
        const fd = new FormData();
        fd.append('token',this.$route.query.token)
        unsubscribe(fd)
      }catch(e) {
        console.error(e);
      }
    }
  }
};
</script>
